import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackageList } from '../../models/IPackage';
import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

export interface IFindPackagesByAllowedOriginResponse {
  packages?: IPackageList;
}

interface IFindPackagesByAllowedOriginQueryParams {
  origin: string;
}

// Reverse-lookup lens backing the by-allowed-origin endpoint added for W-23836064
// (PackageOriginExtractor.findPackagesDeclaringOrigin in the monolith). Used to get a
// fresh, server-authoritative answer to "which packages currently declare this exact
// origin?" at the moment an admin removes it, rather than relying on the possibly-stale
// full package list already held for the ambient PackageImpactWarning preview.
export class FindPackagesByAllowedOriginService {
  public static findPackagesByAllowedOrigin(origin: string): Promise<IFindPackagesByAllowedOriginResponse> {
    return makeJsonRestApiRequest<void, IFindPackagesByAllowedOriginResponse, IFindPackagesByAllowedOriginQueryParams>({
      config: {
        restApiVersion: API_VERSION,
        httpMethod: 'GET',
        endpoint: `${PACKAGES_PATH}/by-allowed-origin`,
      },
      request: null,
      queryParams: { origin },
    });
  }
}
